import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';

// allowUnverified is set on /profile, which hosts the "verify your email"
// card. Everything else is closed to unverified accounts.
export function Protected({ children, requireAdmin = false, allowUnverified = false }) {
  const { user, role, emailVerified, loading } = useAuth();
  if (loading) return <div className="p-8 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!emailVerified && !allowUnverified) return <Navigate to="/profile" replace />;
  if (requireAdmin && role !== 'admin' && role !== 'superadmin') {
    return (
      <div className="p-8">
        <h1 className="text-xl font-semibold">Admins only</h1>
        <p className="text-slate-600 mt-2">This area requires admin permissions.</p>
      </div>
    );
  }
  return children;
}
